import React from 'react';
import ColorScale from '_class/ColorScale';
import { useTranslate } from 'lib/translate';
import DisplayCell from './DisplayCell';

var DisplayMatrix = function DisplayMatrix(_ref) {
  var matrix = _ref.matrix,
      statistic = _ref.statistic;
  var translate = useTranslate();

  if (matrix == null) {
    return null;
  }

  delete matrix.paragraphSet;
  /**
   * @param {object} row
   */

  var getColors = function getColors(row) {
    var showRed = true;

    if (matrix.disableNotAchieved) {
      showRed = false;
    }

    return new ColorScale(getRowCells(row).length).get(showRed);
  };
  /**
   * @param {object} row
   * @returns {array} cells
   */


  var getRowCells = function getRowCells(row) {
    var cells = JSON.parse(JSON.stringify(row.cells));

    if (!matrix.disableNotAchieved) {
      cells.unshift({
        text: translate('Not achieved'),
        id: 'F'
      });
    }

    return cells;
  };
  /**
   * @param {object} row
   * @param {number} index
   * @returns {object} assessmentDetail
   */


  var getCellAssessmentDetails = function getCellAssessmentDetails(row, index) {
    if (statistic == null) {
      return [];
    }

    var foundEntry = statistic.statistics.find(function (stat) {
      return stat.index == index;
    });

    if (foundEntry != null) {
      return foundEntry.assessmentDetails.filter(function (detail) {
        return detail.assessmentBlockPartRow.referenceId == row.id;
      });
    }

    return [];
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "block--assessment-block consume"
  }, /*#__PURE__*/React.createElement("div", {
    className: "display-matrix"
  }, matrix._ParagraphSet.map(function (paragraph) {
    return /*#__PURE__*/React.createElement("div", {
      className: "paragraph",
      key: paragraph.paragraphNr
    }, paragraph.title != null ? /*#__PURE__*/React.createElement("div", {
      className: "matrix-paragraph-title"
    }, paragraph.title) : null, paragraph.subtitle != null ? /*#__PURE__*/React.createElement("div", {
      className: "matrix-paragraph-subtitle"
    }, paragraph.subtitle) : null, paragraph.rows.map(function (row) {
      var colors = getColors(row);
      return /*#__PURE__*/React.createElement("div", {
        className: "df row",
        key: row.id
      }, paragraph != null ? /*#__PURE__*/React.createElement("div", null, paragraph.paragraphNr, ".", row.sentenceNr) : null, /*#__PURE__*/React.createElement("div", {
        className: "column-text"
      }, row.text), /*#__PURE__*/React.createElement("div", {
        className: "cells df"
      }, getRowCells(row).map(function (cell, index) {
        var assessmentDetails = getCellAssessmentDetails(row, index);
        return /*#__PURE__*/React.createElement(DisplayCell, {
          key: cell.id,
          cell: cell,
          color: colors[index],
          assessmentDetails: assessmentDetails
        });
      })));
    }));
  })));
};

export default DisplayMatrix;